import React from "react";
import { ListSubheader, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface ActivityHeaderProps {
  totalPoints: number;
}

const ActivityHeader: React.FC<ActivityHeaderProps> = ({ totalPoints }) => {
  const { t } = useTranslation();

  return (
    <ListSubheader
      disableSticky
      component="div"
      sx={{
        display: "flex",
        justifyContent: "space-between",
        px: 0,
        py: 1,
        bgcolor: "transparent",
        typography: "subtitle2",
      }}
    >
      <Typography
        variant="bodySmall"
        color="common.black"
        letterSpacing="1px"
        fontWeight={600}
        sx={{ textTransform: "uppercase" }}
      >
        {t("myRewardsPage.activity")}
      </Typography>
      <Typography
        variant="bodySmall"
        color="common.black"
        letterSpacing="1px"
        fontWeight={600}
        sx={{ textTransform: "uppercase" }}
      >
        {`${t("myRewardsPage.pointsTotal")}: ${totalPoints}`}
      </Typography>
    </ListSubheader>
  );
};

export default ActivityHeader;
